import { render, staticRenderFns } from "./DevInfo.vue?vue&type=template&id=047d41c6&scoped=true"
import script from "./DevInfo.vue?vue&type=script&lang=js"
export * from "./DevInfo.vue?vue&type=script&lang=js"
import style0 from "./DevInfo.vue?vue&type=style&index=0&id=047d41c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047d41c6",
  null
  
)

export default component.exports